<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { ProgressRootProps } from 'reka-ui';
  import { ProgressIndicator, ProgressRoot } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = withDefaults(
    defineProps<
      ProgressRootProps & {
        class?: HTMLAttributes['class'];
        progressClass?: HTMLAttributes['class'];
        completedClass?: HTMLAttributes['class'];
      }
    >(),
    {
      modelValue: 0,
      progressClass: 'bg-primary',
    },
  );

  const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <ProgressRoot
    data-slot="progress"
    v-bind="delegatedProps"
    :class="cn('bg-primary/20 relative h-2 w-full overflow-hidden rounded-full', props.class)"
  >
    <ProgressIndicator
      data-slot="progress-indicator"
      :class="
        cn(
          'h-full w-full flex-1 transition-all',
          modelValue === 100 && completedClass,
          progressClass,
        )
      "
      :style="`transform: translateX(-${100 - (props.modelValue ?? 0)}%);`"
    />
  </ProgressRoot>
</template>
